
import tab1Image from './assets/images/illustration-features-tab-1.svg';
import tab2Image from './assets/images/illustration-features-tab-2.svg';
import tab3Image from './assets/images/illustration-features-tab-3.svg';
import chromeImg from './assets/images/logo-chrome.svg';
import firefoxImg from './assets/images/logo-firefox.svg';
import operaImg from './assets/images/logo-opera.svg';

export const tabContent = [
	{
		tab: 'Simple Bookmarking',
		image: tab1Image,
		title: 'Bookmark in one click',
		text: 'Organize your bookmarks however you like. Our simple drag-and-drop interface gives you complete control over how you manage your favorite sites.',
	},
	{
		tab: 'Speedy Searching',
		image: tab2Image,
		title: 'Intelligent search',
		text: 'Our powerful search feature will help you find saved sites in no time at all. No need to trawl through all of your bookmarks.',
	},
	{
		tab: 'Easy Sharing',
		image: tab3Image,
		title: 'Share your bookmarks',
		text: 'Easily share your bookmarks and collections with others. Create a shareable link that you can send at the click of a button.',
	}
];

export const extensionContent = [
	{
		name: 'Chrome',
		image: chromeImg,
		version: '62',
	},
	{
		name: 'Firefox',
		image: firefoxImg,
		version: '55',
	},
	{
		name: 'Opera',
		image: operaImg,
		version: '46',
	},
];

export const faqs = [
	{
		question: 'What is Bookmark?',
		answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam eum recusandae nemo pariatur molestiae voluptas, voluptatum voluptate eius harum, repellat a consectetur dolore totam! Culpa inventore voluptates accusamus eius quia.',
	},
	{
		question: 'How can I request a new browser?',
		answer: 'Sed id sapien vulputate purus tristique gravida quis non tortor. Morbi metus urna, dignissim id ex at, bibendum ultrices augue. Sed scelerisque volutpat velit, ac eleifend dui sagittis non. Aliquam erat volutpat.',
	},
	{
		question: 'Is there a mobile app?',
		answer: 'Aenean quis urna id nisi gravida molestie semper non ipsum. Fusce a iaculis nulla. Donec dictum enim a tortor pulvinar tincidunt.',
	},
	{
		question: 'What about other Chromium browsers?',
		answer: 'Cras tempor laoreet enim non volutpat. Suspendisse pulvinar, enim dignissim ornare lobortis, metus orci porta arcu, a facilisis ex metus sed elit.',
	}
];